/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '',
    name: 'home',
    view: 'Dashboard',
    meta: { panel: 'default' }
  },
  {
    path: '/login',
    name: 'Login Page',
    view: 'Login',
    meta: { isFullScreen: true }
  },
  {
    path: '/logout.json',
    view: 'Login',
    name: 'Logout',
    beforeEnter () {
      window.location.href = BASE_URL + '/logout.json'
    }
  },
  {
    path: '/user-management/:logins?',
    name: 'User Management',
    view: 'UserManagement',
    meta: { panel: 'default' }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    view: 'Tasks',
    meta: {
      access: { key: 'task_view', value: true },
      panel: 'default'
    }
  },
  {
    path: '/proxers',
    name: 'Proxers',
    view: 'Proxers',
    meta: {
      access: { key: 'proxer_view', value: true },
      panel: 'default'
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    view: 'Settings',
    meta: {
      access: { key: 'settings_control', value: true, panel: 'default' },
      panel: 'default'
    }
  },
  {
    path: '/cms-deploy',
    name: 'CMSDeploy',
    view: 'CMSDeploy',
    meta: {
      access: { key: 'cms_deploy', value: true, panel: 'default' },
      panel: 'default'
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    view: 'Reports',
    meta: {
      panel: 'default',
      access: { key: 'reports', value: true },
      manual_loaded: true,
    }
  },
  {
    path: '/mail',
    name: 'Mail',
    view: 'Mail',
    meta: { isFullScreen: true, panel: 'default' }
  },
  {
    path: '/payment-handler',
    name: 'Payment Handler',
    view: 'PaymentHandler',
    meta: {
      access: { key: 'payment_handler', value: true, panel: 'default' }
    }
  },
  {
    path: '/kyc',
    name: 'KYC',
    view: 'KYC',
    meta: {
      access: { key: 'payment_handler', value: true, panel: 'default' }
    }
  },
  {
    path: '/autobonus',
    name: 'Autobonus',
    view: 'Autobonus',
    meta: {
      access: { key: 'autobonus', value: true, panel: 'default' }
    }
  },
  {
    path: '/bonus-template',
    name: 'Bonus Template',
    view: 'BonusTemplate',
    meta: {
      access: { key: 'bonus_template', value: true, panel: 'default' }
    }
  },
  {
    path: '/notification-center',
    name: 'Notification Center',
    view: 'NotificationCenter',
    meta: {
      access: { key: 'notification_center', value: true, panel: 'default' }
    }
  },
  {
    path: '/sport-bonus',
    name: 'Sport Bonus',
    view: 'SportBonus',
    meta: {
      access: { key: 'sport_bonus', value: true },
      panel: 'default'
    }
  },
  {
    path: '/bonus-tools/:action?',
    name: 'BonusTools',
    view: 'BonusTools',
    meta: {
      access: { key: 'bonus_tools', value: true, panel: 'default' }
    }
  },
  {
    path: '/blacklist',
    name: 'BlackList',
    view: 'BlackList',
    meta: {
      access: { key: 'blacklist', value: true, panel: 'default' }
    }
  },
  {
    path: '/mail-template',
    name: 'Mail Template',
    view: 'MailTemplate',
    meta: {
      access: { key: 'mail_template', value: true, panel: 'default' }
    }
  },
  {
    path: '/business-intelligence',
    name: 'BI',
    view: 'BI',
    meta: {
      access: { key: 'business_intelligence', value: true, panel: 'default' }
    }
  },
  {
    path: '/two-fa',
    name: 'Two Factor Authentication',
    view: 'TwoFactorAuthentication'
  },
  {
    path: '/daily-report',
    name: 'Daily Report',
    view: 'DailyReport',
    meta: {
      access: { key: 'daily_report', value: true }, panel: 'default'
    }
  },
  {
    path: '/tournaments',
    name: 'Tournaments',
    view: 'Tournaments',
    meta: {
      access: { key: 'tournaments', value: true }, panel: 'default'
    }
  },
  {
    path: '/retention',
    name: 'Retention',
    view: 'Retention',
    meta: {
      access: { key: 'retention', value: true }, panel: 'default'
    }
  },
  {
    path: '/postbacks',
    name: 'Postbacks',
    view: 'Postbacks',
    meta: {
      access: { key: 'postbacks', value: true },
      panel: 'default'
    }
  },
  {
    path: '/kiosk/entities',
    name: 'Entities',
    view: 'kiosk/EntityTree',
    meta: {
      access: { key: 'kiosk.access', value: true }, panel: 'kiosk'
    }
  },
  {
    path: '/kiosk/dashboard',
    name: 'Dashboard',
    view: 'kiosk/Dashboard',
    meta: {
      access: { key: 'kiosk.access', value: true }, panel: 'kiosk'
    }
  },
  {
    path: '/kiosk/pin',
    name: 'Pin',
    view: 'kiosk/Pin',
    meta: {
      access: { key: 'kiosk.pin', value: true }, panel: 'kiosk'
    }
  },
  {
    path: '/kiosk/reports',
    name: 'Reports',
    view: 'kiosk/Reports',
    meta: {
      access: { key: 'kiosk.reports', value: true },
      panel: 'kiosk',
    }
  },
  {
    path: '/kiosk/account_registration',
    name: 'Reports',
    view: 'kiosk/AccountRegistration',
    meta: {
      access: { key: 'kiosk.account_registration', value: true },
      panel: 'kiosk',
    }
  },
  {
    path: '/operators',
    name: 'Operators',
    view: 'Operators',
    meta: {
      access: { key: 'user_control', value: true }, panel: 'default'
    }
  },
  {
    path: '/kiosk/account-list',
    name: 'Accounts',
    view: 'kiosk/AccountList',
    meta: {
      access: { key: 'kiosk.access', value: true }, panel: 'kiosk'
    }
  },
  {
    path: '/kiosk/operators',
    name: 'Operators',
    view: 'Operators',
    meta: {
      access: { key: 'user_control', value: true }, panel: 'kiosk'
    }
  },
  {
    path: '/games',
    name: 'Games',
    view: 'Games',
    meta: {
      access: { key: 'game', value: true }, panel: 'default'
    }
  },
  {
    path: '/currency-rate',
    name: 'Currency Rate',
    view: 'CurrencyRate',
    meta: { panel: 'default' }
  },
  {
    path: '/commissions',
    name: 'Commissions',
    view: 'Commissions',
    meta: {
      access: { key: 'commission', value: true },
      panel: 'default'
    }
  },
  {
    path: '/affiliate_statistic',
    name: 'Affiliate Stats',
    view: 'AffiliateStats',
    meta: {
      access: { key: 'affiliate_statistic', value: true },
      panel: 'default'
    }
  },
  {
    path: '/vip_statistic',
    name: 'Vip Stats',
    view: 'Vip',
    meta: {
      access: { key: 'vip_statistic', value: true },
      panel: 'default'
    }
  },
  {
    path: '/verification',
    name: 'Verification',
    view: 'Verification',
    meta: { panel: 'default' }
  },
  {
    path: '/suspicious-activity-review',
    name: 'SuspiciousActivityReview',
    view: 'SuspiciousActivityReview',
    meta: {
      access: { key: 'suspicious_activity_review', value: true },
      panel: 'default',
    },
  },
  {
    path: '/tools',
    name: 'Tools',
    view: 'Tools',
    meta: {
      access: { key: 'tools', value: true },
      panel: 'default',
    }
  },
  {
    path: '/jackpots',
    name: 'Jackpot',
    view: 'Jackpot',
    meta: {
      access: { key: 'jackpots', value: true },
      panel: 'default',
    }
  },
  {
    path: '/cms/deploy',
    name: 'CMSDeployGeneration',
    view: 'cms/DeployView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/cms/deployed',
    name: 'CMSDeployedContent',
    view: 'cms/DeployedContentView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/cms/schemas',
    name: 'CMSSchemas',
    view: 'cms/SchemasView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/cms/media',
    name: 'CMSMedia',
    view: 'cms/MediaView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/cms/bulk-action',
    name: 'CMSBulkAction',
    view: 'cms/BulkActionView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/cms/type/:typeSlug/:tab?',
    name: 'CMSType',
    view: 'cms/TypeView',
    meta: {
      access: { key: 'cms', value: true },
      panel: 'cms',
    }
  },
  {
    path: '/mirrors-redirectors',
    name: 'Mirrors, Redirectors',
    view: 'MirrorsRedirectors',
    meta: {
      access: { key: 'mirrors', value: true },
      panel: 'default',
    }
  },
  {
    path: '/feature-config',
    name: 'Feature Configs',
    view: 'FeatureConfig',
    meta: {
      access: { key: 'feature_configs', value: true },
      panel: 'default',
    }
  }
]
